import { Injectable } from '@angular/core';
import { EventRegistrationEditActionDto } from './dto/event-registration-edit-action.dto';
import { EventRegistationActionTypeEnum } from './dto/event-registation-action-type.enum';
import { ProfileMin } from 'src/app/profiles/shared/profile-min.model';
import { RegistrationItem } from 'src/app/events/registration/shared/registration-item.model';

@Injectable({
  providedIn: 'root',
})
export class EventRegistrationActionTrackerService {
  private actions: EventRegistrationEditActionDto[] = [];
  private postedSignupIds: number[] = [];
  private postedCustomFieldResponsIds: number[] = [];

  public addAction(action: EventRegistrationEditActionDto) {
    switch (action.Type) {
      case EventRegistationActionTypeEnum.RegistrationProfileChanged:
        this.addRegistrationProfileChangedAction(action);
        break;
      case EventRegistationActionTypeEnum.CreateProfileSet:
        action.OldValue = false;
        this.upsertAction(action);
        break;
      case EventRegistationActionTypeEnum.EventItemQuantityChanged:
        this.addRegistrationItemQuantityChangedAction(action);
        break;
      case EventRegistationActionTypeEnum.CustomFieldCostChanged:
        this.addCustomFieldResponseChangedAction(action);
        break;
      case EventRegistationActionTypeEnum.BenefitChanged:
      case EventRegistationActionTypeEnum.PromoCodeChanged:
      case EventRegistationActionTypeEnum.DoNotInvoiceSet:
        this.upsertAction(action);
        break;
      default:
        this.actions.push(action);
        break;
    }
    this.printActions();
  }

  addRegistrationItemQuantityChangedAction(action: EventRegistrationEditActionDto) {
    let allNewValues: RegistrationItem[] = action.NewValue;
    let allOldValues: RegistrationItem[] = action.OldValue;

    for (let modifiedItem of allNewValues) {
      let originalItem = allOldValues.find((x) => x.EventItemId == modifiedItem.EventItemId);
      if (!this.postedSignupIds.some((x) => x == modifiedItem.EventItemSignUpId)) {
        this.upsertAction({
          Type: EventRegistationActionTypeEnum.EventItemQuantityChanged,
          NewValue: modifiedItem.Quantity,
          OldValue: originalItem.Quantity,
          KeyValue: originalItem.EventItemId,
        } as EventRegistrationEditActionDto);
      }
    }
  }

  addCustomFieldResponseChangedAction(action: EventRegistrationEditActionDto) {
    const responseId = parseInt(action.KeyValue.split(',').pop() || '0');
    if (!this.postedCustomFieldResponsIds.some((x) => x == responseId)) {
      this.upsertAction(action);
    }
  }

  public getActions(): EventRegistrationEditActionDto[] {
    return this.actions;
  }

  public clearActions() {
    this.actions = [];
  }

  public printActions() {
    console.log(this.actions);
  }

  public setPostedSignupIds(postedSignupIds: number[]) {
    this.postedSignupIds = postedSignupIds;
  }

  setPostedResponseIds(postedCustomFieldResponsIds: number[]) {
    this.postedCustomFieldResponsIds = postedCustomFieldResponsIds;
  }

  private upsertAction(action: EventRegistrationEditActionDto) {
    let existingAction = this.actions.find((x) => x.Type == action.Type && x.KeyValue === action.KeyValue);
    if (existingAction) {
      if (existingAction.OldValue == action.NewValue) {
        this.actions.splice(
          this.actions.findIndex((x) => x == existingAction),
          1
        );
      } else {
        existingAction.NewValue = action.NewValue;
      }
    } else if (action.OldValue != action.NewValue) {
      this.actions.push(action);
    }
  }

  private addRegistrationProfileChangedAction(action: EventRegistrationEditActionDto) {
    let newProfile: ProfileMin = action.NewValue;
    let oldProfile: ProfileMin = action.OldValue;
    action.NewValue = newProfile?.ProfileId ?? 0;
    action.OldValue = oldProfile?.ProfileId ?? 0;
    this.upsertAction(action);

    this.upsertAction({
      Type: EventRegistationActionTypeEnum.CreateProfileSet,
      OldValue: newProfile.Member,
      NewValue: newProfile.Member,
    } as EventRegistrationEditActionDto);
  }
}
